import RecipeTile from "./RecipeTile";
import type { Recipe } from "../types";

interface RecipeGridProps {
  recipes: Recipe[];
}

export default function RecipeGrid({ recipes }: RecipeGridProps) {
  if (recipes.length === 0) {
    return (
      <div className="text-center py-20 text-stone-400">
        <p className="text-5xl mb-3">🍽️</p>
        <p className="text-lg font-medium">No recipes found</p>
        <p className="text-sm mt-1">Try adjusting your filters or search</p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {recipes.map((recipe) => (
        <RecipeTile key={recipe.recipeId} recipe={recipe} />
      ))}
    </div>
  );
}
